import { createComponent } from '@front/utils/alpine';
import { debounce } from "lodash-es";

export default createComponent(() => ({
    setup () {
        const step = document.querySelector('.guide_interactive .step_taille');
        const portrait = document.querySelector('.guide_interactive .guide_interactive_portrait');

        const viewport = () => {
            const isPortrait = window.innerWidth > window.innerHeight;

            isPortrait ? step?.classList.add('block') : step?.classList.add('hidden');
            isPortrait ? step?.classList.remove('hidden') : step?.classList.remove('block');
            isPortrait ? portrait?.classList.add('hidden') : portrait?.classList.add('block');
            isPortrait ? portrait?.classList.remove('block') : portrait?.classList.remove('hidden');
        };

        window.addEventListener('orientationchange', debounce(viewport, 250))
    },
}));